import gql from "graphql-tag";

export const CYBERSOURCE_COMPLETE_3DS = gql`
  mutation CybersourceComplete3ds($data: CybersourceComplete3dsInput!) {
    cybersourceComplete3ds(data: $data)
  }
`;
